module.exports = {
  inviter: {
    title: "邀请",
    noLoginRequired: true,
    requiredParams: {
      id: "邀请ID"
    },
    optionalParams: {}
  },
  inviterNotice: {
    title: "邀请提示信息",
    noLoginRequired: true,
    requiredParams: {
      state: "邀请成功与否的状态",
      orgName: "机构名称"
    },
    optionalParams: {}
  }
};
